import Settings from "./Settings.vue";
export default Settings;
